import React from 'react'

export const TabData = React.createContext();